import React, { Suspense } from "react"
import { BrowserRouter as Router, Switch } from "react-router-dom"
import PageProvider from './Context/PageProvider'

import Login from './Pages/Login'
import Messages from './Pages/Messages'
import TicketRates from './Pages/TicketRates'
import Users from './Pages/UserManagament/Admin'
import ProtectedRoute from './ProtectedRoute'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'

function App() {

  return (
    <Suspense fallback={<div>Loading... </div>}>
      <Router>
        <PageProvider>
          <Switch>

            <ProtectedRoute path="/login" exact component={Login} />
            <ProtectedRoute path="/users" exact component={Users} />
            <ProtectedRoute path="/ticket-rates" exact component={TicketRates} />
            <ProtectedRoute path="/" exact component={Messages} />
          </Switch>
        </PageProvider>
      </Router>
    </Suspense>
  );
}

export default App;
